export interface User {
    id?:        number;
    user_name: string;
    password?:  string;
    nick_name: string;
    head_img?:  string;
    role_code: string;
    status?:    number;
    add_time?:  number;
    role_desc?: string;
    labels?:string;
}
export const shipAuth = [
    { label: "采购单号", value: 2 },
    { label: "装货港口", value: 3 },
    { label: "抵达港口", value: 4 },
    { label: "发货单位", value: 5 },
    { label: "货物保险", value: 6 },
    { label: "装船时间", value: 7 },
    { label: "发船时间", value: 8 },
    { label: "到港时间", value: 29 },
    { label: "卸货时间", value: 30 },
    { label: "供应商编码", value: 12 },
    { label: "供应商联系人", value: 13 },
    { label: "供应商电话", value: 14 },
    { label: "销售单号", value: 15 },
    { label: "客户名称", value: 16 },
    { label: "客户联系人", value: 17 },
    { label: "客户电话", value: 18 },
    { label: "货物名称", value: 19 },
    { label: "产品编码", value: 20 },
    { label: "业务经理", value: 21 },
    { label: "联系电话", value: 22 },
    { label: "经办人", value: 23 },
    { label: "经办人电话", value: 24 },
    { label: "租赁日期", value: 27 },
    { label: "编辑时间", value: 28 },
    { label: "货物重量", value: 43 },
    { label: "成本单价", value: 45 },
    { label: "货物价值", value: 47 },
    { label: "运输单价", value: 44 },
    { label: "销售单价", value: 46 },
    { label: "销售数量", value: 48 },
    { label: "入库状态", value: 41 },
    { label: "行驶状态", value: 42 },
  ];